import styled from 'styled-components';
import RoomSvg from '../../assets/mytrips/room.svg';

const RoomIcon = styled(RoomSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default RoomIcon;
